<template>
  <v-row no-gutters>
    <feature-card-basic ref="featureCard" @update:feature="featureFetched" :layer="layer">
      <template #top>
        <sidebar-row class="pr-5 py-2">
          <v-row no-gutters>
            <v-col v-if="isFetched">
              <div class="text-subtitle-2 text-left py-4">
                <v-badge :content="streetLamps.length || '0'">Latarnie</v-badge>
              </div>
              <ribbon-list
                :listItems="streetLamps"
                no-flex
                :right-cols="null"
                :toggle-max-items="4"
                pagination-type="summary"
              >
                <template #itemButtons-prepend="{ item }">
                  <v-row v-if="item.circuits" no-gutters align="center" class="flex-nowrap">
                    <v-col cols="auto" class="flex-shrink-1">
                      <v-row no-gutters>
                        <v-col
                          cols="auto"
                          v-for="([key, count], index) in Object.entries(
                            $_groupByProperty(item.circuits, 'title', null, true)
                          )"
                          :key="index"
                          class="pr-1 py-1 d-flex justify-center"
                        >
                          <v-tooltip bottom color="font">
                            <template #activator="{ on }">
                              <v-chip x-small v-on="on" class="caption">{{ count }}x {{ key }}</v-chip>
                            </template>
                            {{ key }}
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </ribbon-list>
            </v-col>
            <v-col v-else class="pt-2">
              <main-loader />
            </v-col>
          </v-row>
        </sidebar-row>
      </template>
    </feature-card-basic>
  </v-row>
</template>

<script>
import FeatureCardBasic from '@/components/FeatureCardBasic';
import RibbonList from '@/components/RibbonList';
import MainLoader from '@/components/MainLoader';
import SidebarRow from '@/components/SidebarRow';

import { get, call } from 'vuex-pathify';

export default {
  name: 'FeatureCardCalculatedCircuits',
  components: {
    FeatureCardBasic,
    RibbonList,
    SidebarRow,
    MainLoader,
  },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isFetched: false,
    streetLamps: [],
  }),
  computed: {
    circuitNumberAttribute: get('admin/modulesMapping@zdm_data.circuits.circuit_number'),
    cabinetNumberAttribute: get('admin/modulesMapping@zdm_data.circuits.cabinet_number'),
    headsLayerId: get('admin/modulesMapping@zdm_data.layers.head'),
    headsDataSource: get('admin/modulesMapping@zdm_data.datasources.head.datasource'),
    headDisplayAttribute: get('admin/modulesMapping@zdm_data.datasources.head.display_attribute_name'),
    headLampAttribute: get('admin/modulesMapping@zdm_data.street_lamp_fields.zdm_data_head'),
    headLampNumberAttribute: get('admin/modulesMapping@zdm_data.datasources.head.street_lamp_number'),
    lampDatasource: get('admin/modulesMapping@zdm_data.datasources.street_lamp.datasource'),
  },
  methods: {
    getLayerFeatures: call('layers/getLayerFeatures'),
    zoomToStreetLamp(data) {
      this.$root.$emit('zoomToDatasourceFeature', this.lampDatasource, data.item.id);
    },
    async featureFetched(feature) {
      this.isFetched = false;
      const properties = feature.properties;
      try {
        if (!properties[this.cabinetNumberAttribute] && !properties[this.circuitNumberAttribute]) {
          this.streetLamps = [];
          return;
        }
        const heads = await this.getLayerFeatures({
          layer_id: this.headsLayerId,
          features_filter: {
            '!AND': [
              ...(properties[this.cabinetNumberAttribute]
                ? [
                    {
                      $EQUAL: {
                        [`${this.headsDataSource}.${this.cabinetNumberAttribute}`]: {
                          value: properties[this.cabinetNumberAttribute],
                        },
                      },
                    },
                  ]
                : []),
              ...(properties[this.circuitNumberAttribute]
                ? [
                    {
                      $EQUAL: {
                        [`${this.headsDataSource}.${this.circuitNumberAttribute}`]: {
                          value: properties[this.circuitNumberAttribute],
                        },
                      },
                    },
                  ]
                : []),
            ],
          },
          params: {
            with_count: false,
            with_geometry: false,
          },
        });
        const lampsObj = this.$_groupByProperty(
          heads.data.data.features.features,
          'properties',
          this.headLampNumberAttribute
        );
        this.streetLamps = Object.keys(lampsObj).reduce((acc, key) => {
          acc.push({
            circuits: lampsObj[key]?.map(head => {
              return {
                title: head.properties[this.headDisplayAttribute],
              };
            }),
            id: lampsObj[key][0].properties[this.headLampAttribute],
            title: key,
            buttons: [
              {
                icon: 'mdi-magnify',
                clickHandler: this.zoomToStreetLamp,
                tooltip: this.$i18n.t('sidebar.zoomOnMap'),
              },
            ],
          });
          return acc;
        }, []);
      } finally {
        this.isFetched = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ribbon-list-buttons-row {
  flex-wrap: nowrap !important;
}
</style>
